import React from "react";
import { FaRegStar, FaStar, FaStarHalfAlt } from "react-icons/fa";
import classNames from "./classNames";

const RatingStars = ({ rating = 0, count, className, size = "medium" }) => {
  const normalizedRating = Math.min(5, Math.max(0, Number(rating) || 0));
  const roundedRating = Math.round(normalizedRating * 2) / 2;
  const label = `${normalizedRating.toFixed(1)} out of 5 stars${
    Number.isFinite(Number(count)) ? `, ${Number(count)} reviews` : ""
  }`;

  return (
    <span
      className={classNames("rating-stars", `rating-stars--${size}`, className)}
      role="img"
      aria-label={label}
    >
      <span className="rating-stars__icons" aria-hidden="true">
        {[1, 2, 3, 4, 5].map((position) => {
          if (roundedRating >= position) {
            return <FaStar key={position} />;
          }
          if (roundedRating === position - 0.5) {
            return <FaStarHalfAlt key={position} />;
          }
          return <FaRegStar key={position} />;
        })}
      </span>
      {Number.isFinite(Number(count)) && (
        <span className="rating-stars__count" aria-hidden="true">
          ({Number(count).toLocaleString()})
        </span>
      )}
    </span>
  );
};

export default RatingStars;
